import { render } from "./EditFacility.vue?vue&type=template&id=47256d14&scoped=true"
import script from "./EditFacility.vue?vue&type=script&lang=js"
export * from "./EditFacility.vue?vue&type=script&lang=js"

import "./EditFacility.vue?vue&type=style&index=0&id=47256d14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47256d14"]])

export default __exports__